<template>
  <div
    style="
      width: 100%;
      height: calc(100% - 50px);
      overflow-y: auto;
      padding: 0 10px;
      box-sizing: border-box;
    "
    v-loading="loading"
  >
    <el-row
      style="
        text-align: right;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: right;
      "
    >
      <div style="flex: 1; text-align-last: right; margin-right: 10px">
        <el-button
          @click="submitProjectData"
          type="warning"
          size="mini"
          :disabled="disabled"
          v-if="!disabled"
          icon="el-icon-upload2"
          >提交</el-button
        >
      </div>
      <!-- <span
        v-if="Status == 4"
        style="font-size: 14px; color: red; margin-right: 20px"
        >驳回原因：{{ RejectReason }}</span
      > -->
      <div style="margin-right: 20px">
        <el-tag v-if="Status == 0" type="warning" size="medium"
          >当前状态：未提交
        </el-tag>
        <el-tag v-if="Status == 1" type="warning" size="medium"
          >当前状态：已提交
        </el-tag>
        <el-tag v-if="Status == 2 || Status == 3" type="success" size="medium"
          >当前状态：已审核
        </el-tag>
        <el-tag
          v-if="Status == 4"
          style="
            background-color: #ebb563;
            color: #ffffff;
            border-color: #ebb563;
          "
          size="medium"
          >当前状态：驳回
        </el-tag>
      </div>
    </el-row>
    <div style="display: flex; width: 100%">
      <div style="width: calc(100% - 260px); border-right: 1px solid #dcdfe6">
        <div v-for="(eell, indexeell) in tableData" :key="eell.Id">
          <el-table :data="[eell]" style="width: 100%">
            <el-table-column prop="TypeName" width="200">
              <span slot="header">
                <span>{{ indexeell + 1 + '.' + eell.TypeName }}</span>
                <el-popover
                  v-if="
                    TypeData.find((vv) => vv.DicValue == eell.Type)?.Remark ||
                    false
                  "
                  placement="bottom-start"
                  :open-delay="100"
                  width="200"
                  trigger="hover"
                  :content="
                    TypeData.find((vv) => vv.DicValue == eell.Type)?.Remark ||
                    ''
                  "
                  popper-class="table-popper"
                >
                  <i class="el-icon-question" slot="reference"></i>
                </el-popover>
              </span>
              <template slot-scope="scope"> {{ '' }} </template>
            </el-table-column>

            <el-table-column prop="Type" label="文件信息" :resizable="false">
              <template slot-scope="scope">
                <el-upload
                  :limit="9"
                  class="upload-demo"
                  :action="
                    $rootUrl +
                    `/Base_Manage/Upload/ProjectOssUploadFileByForm?ProjectId=${base_Supplier.ProjectId}&UserId=${base_Supplier.Id}&type=2&SupplierId=${base_Supplier.Id}`
                  "
                  accept="image/*, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                  :ref="'upload_' + scope.row.Type"
                  :before-remove="(file) => beforeRemove(file, scope.row)"
                  multiple
                  :disabled="scope.row.IsUpStatus || disabled"
                  :headers="{
                    Authorization: 'Bearer ' + TokenCache.getToken(),
                  }"
                  :file-list="scope.row.DocumentListCopy"
                  :on-exceed="handleExceed"
                  :on-preview="handlePreview"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, scope.row)
                  "
                  :before-upload="
                    (file, fileList) => beforeUpload(scope.row, file, fileList)
                  "
                  :on-success="
                    (response, file, fileList) =>
                      handleSuccess(response, file, fileList, scope.row)
                  "
                  :on-error="
                    (err, file, fileList) =>
                      handleError(err, file, fileList, scope.row)
                  "
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, scope.row)
                  "
                  :auto-upload="true"
                >
                  <div v-if="!disabled">
                    <el-button
                      size="mini"
                      type="primary"
                      :disabled="scope.row.IsUpStatus || disabled"
                      :loading="scope.row.IsUpStatus"
                      >{{
                        scope.row.IsUpStatus ? '上传中' : '选择文件'
                      }}</el-button
                    >
                  </div>
                </el-upload>
                <!-- <div style="height: 10px"></div> -->
              </template>
            </el-table-column>
            <el-table-column prop="Size" label="文件大小" align="left">
              <template slot-scope="scope">
                <ul v-if="scope.row.DocumentListCopy?.length > 0">
                  <li
                    v-for="(item, indd) in scope.row.DocumentListCopy"
                    :key="item.uid"
                    :style="`display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                font-size: 14px;
                color: #606266;
                line-height: 1.8;
                margin-top:${indd == 0 ? '10px' : '5px'}
                box-sizing: border-box;
                border-radius: 4px;
                border-bottom:1px solid rgba(255,255,255,0);
                width: 100%;`"
                  >
                    <!-- <div
                      style="
                        width: calc(100% - 120px);
                        display: flex;
                        align-items: center;
                      "
                    >
                      {{ item.name }}
                    </div> -->
                    <div
                      style="width: 120px; display: flex; align-items: center"
                    >
                      {{ setSize(item.size) }}
                    </div>
                  </li>
                </ul>
                <span v-else>暂无数据</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="SubmitTime"
              label="提交时间"
              width="200"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.SubmitTime
                    ? moment(scope.row.SubmitTime).format('YYYY-MM-DD HH:mm:ss')
                    : ''
                }}
              </template>
            </el-table-column>
            <el-table-column label="上传状态" width="100" align="center">
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-check"
                  style="font-size: 20px; color: #67c23a"
                  v-if="
                    scope.row.DocumentListCopy?.length > 0 &&
                    scope.row.DocumentListCopy?.every(
                      (item) => item.status === 'success'
                    )
                  "
                ></i>
                <i
                  v-else
                  class="el-icon-circle-close"
                  style="font-size: 20px; color: #f56c6c"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <div
            style="
              display: flex;
              width: 100%;
              align-items: center;
              font-size: 14px;
              margin-top: 10px;
              margin-bottom: 10px;
              color: #ebb563;
            "
            v-if="approvalComments[eell.Type] && RejectReason && Status == 4"
          >
            <span
              style="
                display: inline-block;
                width: 130px;

                font-weight: bold;

                display: flex;
                align-items: center;

                margin-right: 10px;
              "
              >审核意见</span
            >
            <span style="display: inline-block; width: calc(100% - 120px)">
              {{ approvalComments[eell.Type].content }}
            </span>
            <!-- <el-input
              v-model="approvalComments[eell.Type].content"
              placeholder="未输入内容"
              style="width: calc(100% - 120px)"
              type="textarea"
              :rows="2"
              disabled
              resize="none"
              size="mini"
            ></el-input> -->
          </div>
        </div>

        <div style="height: 50px"></div>
      </div>
      <div style="width: 220px; margin-left: 20px" :class="StatuClass">
        <div
          v-for="(ele, index) in tableData"
          :key="ele.Type"
          :style="`height: calc(100% / ${tableData.length});min-height: 150px;`"
        >
          <div style="height: 100%; display: flex">
            <div class="steps-left">
              <div
                :class="[
                  'steps',
                  ele.DocumentList?.length > 0 ? 'steps-success' : '',
                ]"
              >
                <i
                  :class="'el-icon-check'"
                  v-if="ele.DocumentList?.length > 0"
                ></i>
                <span v-else>{{ index + 1 }}</span>
              </div>
              <div
                :class="[
                  'steps-left-line',
                  ele.DocumentList?.length > 0 ? 'steps-success-line' : '',
                ]"
                v-if="index != tableData.length - 1"
              ></div>
            </div>
            <div class="steps-right">
              <div class="steps-right-title">
                <span
                  :class="[ele.DocumentList?.length > 0 ? 'steps-success' : '']"
                  style="cursor: pointer"
                  >{{ index + 1 }}.{{ ele.TypeName }}</span
                >
              </div>
              <!-- <div
                class="steps-right-description"
                v-if="approvalComments[ele.Type]"
              >
                <div class="approval-comment">
                  <el-tooltip effect="dark" placement="left" :open-delay="300">
                    <div slot="content" style="width: 300px">
                      {{ approvalComments[ele.Type].content }}
                    </div>
                    <div class="comment-content">
                      {{ approvalComments[ele.Type].content }}
                    </div>
                  </el-tooltip>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-row style="text-align: right; margin-top: 10px" v-if="!disabled">
      <el-checkbox
        v-model="isUpCheckbox"
        @change="upCheckboxChange"
        style="margin-right: 20px"
        :disabled="disabled"
        >全选</el-checkbox
      >
      <el-button type="primary" @click="upAllData" size="mini" :disabled="disabled"
        >上传文档信息</el-button
      >
    </el-row> -->
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import moment from 'moment'

export default {
  data() {
    return {
      TokenCache,
      tableData: [],
      disabled: false,
      base_Supplier: {},
      isUpCheckbox: false,
      loading: false,
      TypeData: [],
      moment,
      Status: '',
      RejectReason: '',
      approvalComments: {},
    }
  },
  props: {},
  components: {},
  methods: {
    //提交项目数据
    submitProjectData() {
      this.$confirm(
        '您确定要提交当前资质资料吗？提交后将不可更改, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loading = true
        this.$http
          .post(
            `/Device_TypeWork/Device_TypeTemplate/SubmitSupplierFiles?ProjectId=${this.base_Supplier.ProjectId}&SupplierId=${this.base_Supplier.Id}`
          )
          .then((res) => {
            this.loading = false
            if (res.Success) {
              this.$notify.success('项目资料提交成功')
              this.disabled = true
              this.Status = 1
              this.getDataList()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    //保存数据
    async submitData(item, isDete) {
      console.log(item, 'item')
      this.loading = true
      await this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/SaveSupplierFiles', {
          ...item,
        })
        .then((res) => {
          this.loading = false
          if (res.Success) {
            if (!isDete) {
              this.$notify.success(`【${item.TypeName}】文档信息上传保存成功`)
            } else {
              this.$notify.success(`删除成功`)
            }
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    upData(row) {
      if (row.DocumentListCopy.length <= 0) {
        return this.$notify.error('请选择需要上传的文件')
      }
      console.log(this.$refs['upload_' + row.Type])
      let flag = row.DocumentListCopy.every((val) => {
        return val.status == 'success'
      })
      if (flag) {
        this.submitData(row)
        return
      }

      this.$set(row, 'IsUpStatus', true)
      this.$refs['upload_' + row.Type].submit()
    },
    //上传全部
    async upAllData() {
      // let arr = this.infoObj[this.DataInfo.DeviceTab].map((item) => {
      //   return item.device_TypeTwoDocuments.filter((vall) =>
      //     item.cList.includes(vall.Type)
      //   );
      // });
      //找到所有的选中行
      let ArrData = this.tableData.filter((item) => {
        return item.checked
      })
      if (ArrData.length <= 0) {
        return this.$notify.error('请选择需要上传的文档信息')
      }
      //选中但为选择文件
      let errArr = []
      ArrData.forEach((item) => {
        if (item.DocumentListCopy.length <= 0) {
          errArr.push(item)
        }
      })
      if (errArr.length > 0) {
        return this.$notify.error('选择的文档信息中有未选择文件，请核实后上传')
      }

      let ArrDataSuccess = []
      ArrData.forEach((item) => {
        let flag = item.DocumentListCopy.every((val) => {
          return val.status == 'success'
        })
        //如果行内都上传完毕则添加成功数据
        if (flag) {
          ArrDataSuccess.push(item)
        } else {
          //不是则上传
          console.log(item, 'itemitem')
          item.IsUpStatus = true
          this.$refs['upload_' + item.Type].submit()
        }
      })
      //如果选中的行都是上传完毕 则循环执行一遍保存
      if (ArrDataSuccess.length === ArrData.length) {
        for await (const item of ArrData) {
          await this.submitData(item)
        }
        console.log('00000000000000000000000000000000000000')
        // ArrData.forEach((item) => {
        //   this.submitData(item.Type);
        // });
      } else {
        for await (const item of ArrDataSuccess) {
          await this.submitData(item)
        }
      }
      console.log(ArrData)
    },
    //全选选择
    upCheckboxChange(val) {
      console.log(val)
      this.tableData.forEach((item) => {
        this.$set(item, 'checked', val)
      })
    },
    //选择多选
    checkedChange(row) {
      // if (row.checked) {
      //   this.$set(row, "checked", false);
      // } else {
      //   this.$set(row, "checked", true);
      // }

      console.log(row.checked, 'checkedChange')
      // let arr = this.infoObj[this.DataInfo.DeviceTab].map((item) => {
      //   return item.device_TypeTwoDocuments.filter((vall) =>
      //     item.cList.includes(vall.Type)
      //   );
      // });
      // let ArrData = arr.flat(9999999);
      this.isUpCheckbox = this.tableData.every((val) => {
        return val.checked
      })

      //  this.infoObj[this.DataInfo.DeviceTab].forEach((item) => {
      //     let data = item.device_TypeTwoDocuments.filter((vall) =>
      //       item.cList.includes(vall.Type)
      //     );
      //     data.forEach((ele) => {
      //       console.log(ele, "22222");

      //       this.$set(ele, "checked", true);
      //     });
      //   });
      console.log(row)
    },
    //字节转换
    setSize(size) {
      let data = ''
      const _size = Number.parseFloat(size)
      if (_size < 1 * 1024) {
        //如果小于0.1KB转化成B
        data = _size.toFixed(2) + 'B'
      } else if (_size < 1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        data = (_size / 1024).toFixed(2) + 'KB'
      } else if (_size < 1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        data = (_size / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        //其他转化成GB
        data = (_size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }
      const size_str = data + ''
      const len = size_str.indexOf('.')
      const dec = size_str.substr(len + 1, 2)
      if (dec == '00') {
        //当小数点后为00时 去掉小数部分
        return size_str.substring(0, len) + size_str.substr(len + 3, 2)
      }
      return size_str
    },
    getDataList() {
      this.$http
        .post(
          `Device_TypeWork/Device_TypeTemplate/GetPriejctSupplierTypeFiles?ProjectId=${this.base_Supplier.ProjectId}&SupplierId=${this.base_Supplier.Id}`
        )
        .then((res) => {
          if (res.Success) {
            this.tableData = []
            this.TypeData = res.Data.TypeData
            this.tableData = res.Data.TableData
            this.disabled =
              res.Data.Status == 1 ||
              res.Data.Status == 2 ||
              res.Data.Status == 3
                ? true
                : false
            this.Status = res.Data.Status
            this.RejectReason = res.Data.RejectReason
            // this.disabled = res.Data.Status ? true : false;
            // if (this.TypeData.length === this.tableData.length) {
            //   return;
            // }
            this.TypeData.forEach((item) => {
              let dataIndex = this.tableData.findIndex((val) => {
                return val.Type === item.DicValue
              })
              if (dataIndex > -1) {
                this.$set(this.tableData[dataIndex], 'checked', false)
                this.$set(this.tableData[dataIndex], 'IsUpStatus', false)
                this.$set(this.tableData[dataIndex], 'UpStatus', false)
                this.$set(
                  this.tableData[dataIndex],
                  'DocumentListCopy',
                  JSON.parse(
                    JSON.stringify(this.tableData[dataIndex].DocumentList)
                  )
                )

                return
              }
              this.tableData.push({
                ProjectId: this.base_Supplier.ProjectId,
                SupplierId: this.base_Supplier.Id,
                Type: item.DicValue,
                TypeName: item.DicName,
                // 上传的列表 后台需要的格式
                DocumentList: [],
                // 上传的列表 前端上传组件需要的格式
                DocumentListCopy: [],
                // 选中
                checked: false,
                //是否上传中
                IsUpStatus: false,
                //是否全部上传完毕
                UpStatus: false,
              })
            })
            if (
              res.Data.RejectReason &&
              JSON.parse(res.Data.RejectReason).length > 0
            ) {
              JSON.parse(res.Data.RejectReason).forEach((item) => {
                this.$set(this.approvalComments, item.stepKey, item)
              })
              console.log(this.approvalComments, 'this.approvalComments')
            }
            console.log(this.tableData, 'tableData')
          }
        })
    },
    handleExceed(files, fileList) {
      this.$notify.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      )
    },
    handlePreview(file) {
      console.log(file)
      window.open(file.url || file.response.Url || file.response.url)
    },
    //文件改变状态
    handleChange(file, fileList, row) {
      // this.form[item.FiledKey + "fileList"] = [...fileList];
      // this.DataInfo[this.DataInfo.DeviceTab][Type + "List"] = [...fileList];
      this.$set(row, 'DocumentListCopy', fileList)
      // console.log(file, fileList, item, "文件改变状态");
    },
    beforeRemove(file, item) {
      console.log(file, item, '删除之前文件')
      const isImage = file?.raw?.type.startsWith('image/')
      const allowedDocumentExtensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ]
      const fileExtension = file.name.split('.').pop().toLowerCase()
      if (!isImage && !allowedDocumentExtensions.includes(fileExtension)) {
        return true
      }
      return new Promise((response, reject) => {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            console.log(file)
            return response()
          })
          .catch(() => {
            return reject()
          })
      })
    },
    //上传删除文件
    async handleRemove(file, fileList, row) {
      console.log(file, fileList, row, '删除文件')
      // this.DataInfo[this.DataInfo.DeviceTab][row.Type + "List"] = fileList;
      // console.log(this.form[item.FiledKey + "fileList"], "fileList");
      let index = row.DocumentListCopy.findIndex((val) => {
        return val.uid === file.uid
      })
      if (index > -1) {
        row.DocumentListCopy.splice(index, 1)
        row.DocumentList.splice(index, 1)
      }
      if (file.status == 'success') {
        //如果已上传的删除则执行删除接口
        console.log(row, 'rrrrrrr')
        this.submitData(row, true)
      }
    },
    beforeUpload(row, file, fileList) {
      const isImage = file.type.startsWith('image/')
      const allowedDocumentExtensions = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
      ]
      const fileExtension = file.name.split('.').pop().toLowerCase()

      // 验证是否为图片或文档
      if (!isImage && !allowedDocumentExtensions.includes(fileExtension)) {
        this.$notify.error('只能上传图片或文档文件！')
        return false
      } else {
        this.$set(row, 'IsUpStatus', true)
        return true
      }
    },
    //上传失败
    handleError(err, file, fileList, row) {
      console.log(err, file, fileList, row, '上传失败')

      this.$set(row, 'IsUpStatus', false)
      this.$notify.error('上传失败')
    },
    //上传成功
    handleSuccess(response, file, fileList, row) {
      console.log(
        JSON.parse(
          JSON.stringify({
            response,
            file,
            fileList,
            row,
          })
        ),
        '22222222222222'
      )
      console.log(
        JSON.parse(JSON.stringify(row.DocumentListCopy)),
        'DocumentListCopy'
      )

      //上传成功的赋值到保存参数里
      if (response.code == '200' && file.status == 'success') {
        console.log(response.name, 'response.name')
        row.DocumentList = [
          ...row.DocumentList,
          {
            name: file.name,
            size: file.size,
            uid: file.uid,
            url: file.response.url,
            status: file.status,
            resname: response.name,
          },
        ]
        // console.log(
        //   this.DataInfo[this.DataInfo.DeviceTab][row.Type],
        //   "TypeTypeTypeTypeTypeType"
        // );
      }
      //验证是否全部上传完毕
      row.UpStatus = fileList.every((val) => {
        return val.status == 'success'
      })
      //全部上传完毕保存数据
      if (row.UpStatus) {
        row.IsUpStatus = false
        this.submitData(row)
      }
      // console.log(JSON.parse(JSON.stringify(response)), "response");
      // console.log(JSON.parse(JSON.stringify(file)), "file");
      // console.log(JSON.parse(JSON.stringify(fileList)), "fileList");
      // console.log(JSON.parse(JSON.stringify(item)), "item");
      // console.log(response, file, fileList, item, "上传成功");
      // if (this.isUp) {
      //   this.submitData();
      // }
      // this.form[item.FiledKey] = file.response.Data;
    },
  },
  mounted() {},
  created() {
    this.base_Supplier = window.localStorage.getItem('base_Supplier')
      ? JSON.parse(window.localStorage.getItem('base_Supplier'))
      : {}
    console.log(this.base_Supplier, 'this.base_Supplier')
    if (this.base_Supplier.ProjectId) {
      this.getDataList()
    }
  },
  computed: {
    StatuClass() {
      return `steps-box Status${this.Status}`
    },
  },
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload-list {
  padding: 5px;
}
::v-deep .upload-demo {
  display: flex;
  align-items: center;
}
.steps-box {
  .steps-left {
    width: 25px;
    height: 100%;
    margin-right: 10px;
    .steps {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      border: 2px solid #c0c4cc;
      color: #c0c4cc;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .steps-success {
      border: 2px solid #67c23a;
      color: #67c23a;
      font-size: 18px;
    }
    .steps-left-line {
      width: 2px;
      height: calc(100% - 25px);
      background: #c0c4cc;
      margin: 0 auto;
    }
    .steps-success-line {
      background: #67c23a;
    }
  }
  .steps-right {
    width: calc(100% - 35px);
    height: 100%;
    // overflow-y: auto;
    position: relative;
    .steps-success {
      color: #67c23a;
    }
    .steps-right-title {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      // position: sticky;
      // top: 0;
      // background: #fff;
      // z-index: 1;
    }
    .steps-right-description {
      font-size: 14px;

      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 5px;
      padding-right: 5px;
      height: calc(100% - 45px);
      overflow: hidden;
      position: relative;
      .comment-content {
        line-height: 1.6;
        color: #303133;
        word-wrap: break-word;
        word-break: break-all;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #f5f7fa;
        border-radius: 4px;
      }
    }
  }
}
// .Status1 {
//   .steps-left {
//     .steps-success {
//       border: 2px solid #e6a23c;
//       color: #e6a23c;
//       font-size: 18px;
//     }
//     .steps-success-line {
//       background: #e6a23c;
//     }
//   }
//   .steps-right {
//     .steps-success {
//       color: #e6a23c;
//     }
//   }
// }
// .Status4 {
//   .steps-left {
//     .steps-success {
//       border: 2px solid #f56c6c;
//       color: #f56c6c;
//       font-size: 18px;
//     }
//     .steps-success-line {
//       background: #f56c6c;
//     }
//   }
//   .steps-right {
//     .steps-success {
//       color: #f56c6c;
//     }
//   }
// }
::v-deep .el-upload-list {
  padding: 5px;
}
::v-deep .upload-demo {
  display: flex;
  align-items: center;
}
::v-deep .el-upload-list {
  width: calc(100% - 100px);
}
</style>
